import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Color } from '@figure/frontlib-gui';

const DeleteLink = styled.span`
  cursor: pointer;
  text-decoration: underline;
  color: ${Color.MEDIUM_GREY};
  padding-left: 10px;
`;

const PlaidDelete = ({ handleClick }) => <DeleteLink onClick={handleClick}>Delete</DeleteLink>;

PlaidDelete.propTypes = {
  handleClick: PropTypes.func.isRequired,
};

export default PlaidDelete;
